import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useExamCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/exam', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-list'] });
    }
  });
};

export const useExamUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/exam/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-list'] });
      queryClient.invalidateQueries({ queryKey: ['exam-get'] });
    }
  });
};

export const useExamDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/exam/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-list'] });
    }
  });
};

export const useExamAddQuestions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ examId, data }: { examId: string; data: any }) => {
      const res = await request.post(`/exam/${examId}/questions`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-questions-list'] });
    }
  });
};

export const useExamQuestionUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ questionId, data }: { questionId: string; data: any }) => {
      const res = await request.patch(`/exam/question/${questionId}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-questions-list'] });
    }
  });
};

export const useExamQuestionDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (questionId: string) => {
      const res = await request.delete(`/exam/question/${questionId}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exam-questions-list'] });
    }
  });
};
